import React, { useEffect, useRef, useState, useCallback, memo } from 'react';
import { selectUser } from '@reduxLocal/selectors/userSelectors';
import { View, Pressable, Animated, ScrollView, Image } from 'react-native';
import styles from '@stylesheet';
import { Text } from '@constants/Themed';
import { Title } from '@constants/Themed';
import { LinearGradient } from 'expo-linear-gradient';
import { AntDesign } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import DefaultCardView from '../DefaultCardView';
import MapView from 'react-native-maps';
import { Swipeable } from 'react-native-gesture-handler';
import { Circle } from 'react-native-maps';
import apis from '@api/api';
import moment from 'moment';
import useGlobalUser from '@hooks/getGlobalUser';
import parseByDelimiter from '@utils/parseByDelimiter';
import DropDownView from '@components/Global/DropDownView';
import Button from '@components/UI/Button/Button';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

const FavouriteDataItem = ({ item, index, handleShareState, listHorizontal, handleRefresh, handleShareModal, handleActionModal, handleDeleteModal, handleSettingsModal }) => {
  const swipeRef = useRef(null);
  const [showInfo, setShowInfo] = useState(false);
  const navigation = useNavigation();
  const globalDate = useSelector((state:DefaultRootState) => state.UI.dateFormat);

  const renderLeftActions = () => {

    const IconView = (props) => {
      return (
        <View style={[styles.centerEverything, { paddingVertical: 2, padding: 10, flex: 1, backgroundColor: props.disabled ? 'grey' : 'transparent', minHeight: 60, minWidth: 80, borderTopStartRadius: props.index == 0 ? 20 : 0, borderBottomStartRadius: props.index == 4 ? 20 : 0 }]}>
          {props.children}
        </View>
      )
    }

    return (
      <View style={{ maxWidth: 150 }}>
        <LinearGradient colors={['rgb(90,192,234)', '#1E90FF']} style={[styles.centerEverything, { marginVertical: 50, flexDirection: 'column', minHeight: '80%', alignSelf: 'stretch', justifyContent: 'center', borderTopLeftRadius: 20, borderBottomLeftRadius: 20, paddingVertical: 20, gap: 5 }]}>
          <IconView index={0}>
            <View style={styles.centerEverything}>
              <Text adjustsFontSizeToFit style={{ fontSize: 22, color: 'white' }}>{item.count ? item.count : 0}</Text>
              <Title style={{ color: "white", flex: 1, fontSize: 18 }}>Docs</Title>
            </View>
          </IconView>
          <View style={{ top: -2, minHeight: 1, width: '85%', backgroundColor: 'white', borderRadius: 4, opacity: .6 }} />
          <IconView disabled={!item.permission} index={3}>
            <Pressable onPress={() => handleShareState(item)} disabled={!item.permission}>
              <AntDesign name="share-alt" size={25} color="white" style={{ flex: 1, verticalAlign: 'middle', textAlign: 'center' }} />
              <Title style={{ color: "white", flex: 1, textAlign: 'center' }}>Share</Title>
            </Pressable>
          </IconView>
          <View style={{ top: -2, minHeight: 1, width: '85%', backgroundColor: 'white', borderRadius: 4, opacity: .6 }} />
          <IconView disabled={!item.permission} index={1}>
            <Pressable onPress={() => { handleActionModal(item) }} disabled={!item.permission} >
              <AntDesign name="contacts" size={25} color="white" style={{ flex: 1, verticalAlign: 'middle', textAlign: 'center' }} />
              <Title style={{ color: "white", flex: 1, textAlign: 'center' }}>Actions</Title>
            </Pressable>
          </IconView>
          <View style={{ top: -2, minHeight: 1, width: '85%', backgroundColor: 'white', borderRadius: 4, opacity: .6 }} />
          <IconView disabled={!item.permission} index={2}>
            <Pressable onPress={() => handleSettingsModal(item)} disabled={!item.permission}>
              <AntDesign name="setting" size={25} color="white" style={{ flex: 1, verticalAlign: 'middle', textAlign: 'center', minWidth: '20%' }} />
              <Title style={{ color: "white", flex: 1, textAlign: 'center', paddingHorizontal: 3 }}>Settings</Title>
            </Pressable>
          </IconView>
        </LinearGradient>
      </View>
    );
  };

  return (
    <Swipeable ref={swipeRef} renderLeftActions={renderLeftActions} key={item?._id} containerStyle={{ backgroundColor: "transparent", marginVertical: 6, minWidth: 300, width: '98%', maxWidth: listHorizontal ? undefined : 320 }}>
      {/* TODO remove modals from each sub-component*/}
      <DropDownView hideInitial={true} cardTitle={<View style={{ marginVertical: -10, flexDirection: 'row' }}>
        <View style={{ alignSelf: 'stretch', minWidth: '90%' }}>
          <Title numberOfLines={1} adjustsFontSizeToFit style={{ color: 'white' }}>{parseByDelimiter(item.dataTitle)}</Title>
          <Text style={{ top: -5 }}>Created: {moment(item.createdAt).format(globalDate)}</Text>
        </View>
        <Pressable style={{ alignSelf: 'center', justifyContent: 'flex-end' }} onPress={() => setShowInfo(!showInfo)}><AntDesign name="infocirlceo" size={24} color={showInfo ? 'white' : "black"} />
        </Pressable>
        <Pressable style={{ flex: 1, minWidth: 20, alignSelf: 'flex-end', top: -10, left: -5 }}>
          {/* <Image source={{ uri: item.owner.profile_information.avatar.img }} style={{ borderWidth: 2, borderColor: 'white', overflow: 'hidden', resizeMode: 'contain', borderRadius: 20, height: 40, width: 40 }} /> */}
        </Pressable>
      </View>}>
        <View style={{ flex: 1, alignSelf: 'stretch', justifyContent: 'space-around' }}>
          <Text style={{ flex: 1 }}>{item.description}</Text>
          <Text style={{flex:1}}>Number of documents: {item.count}</Text>
          <Button buttonText={"Open"} customStyle={{ position: 'relative', alignSelf: 'flex-end' }} onPress={() => navigation.navigate('DataBrowser', { requestId: item._id, title: item.dataTitle })} />
        </View>
      </DropDownView>
    </Swipeable>
  )
};
export default memo(FavouriteDataItem);